<script lang="ts" setup>
    import type { SignaturePadRef } from '@/interfaces/SignaturePadRef';
    import { isBlankOrEmpty } from '@/utils';
    import { ref, onDeactivated, onUnmounted, reactive } from 'vue';
    import Vue3Signature from 'vue3-signature';

    const signature = ref<string>('');

    const props = defineProps<{
        modelValue: number | string | boolean | undefined | 'Yes' | 'No',
        min: number | undefined,
        max: number | undefined,
        options: string[] | string | undefined
    }>();
    const emit = defineEmits(["update", "next"]);
    const signaturePad = ref<SignaturePadRef>()
    const name = ref<string>('');
    const error = ref<boolean>(false);
    const signaturePadState = reactive({
        count: 0,
        option: {
            penColor: 'rgb(0, 0, 0)',
            backgroundColor: 'rgb(255,255,255)'
        },
        disabled: false
    });

    const saveSignature = () => {
        emit('update');
    }
    const clearSignature =() => signaturePad.value!.clear();

    let int: number = 0;    
    const clearInt = () => { window.clearInterval(int); };
    onDeactivated(clearInt);
    onUnmounted(clearInt);
    const load = (val: string | number | boolean | undefined) => {
        if (val != undefined && val?.toString().indexOf("|") > -1) {
            const parts = val.toString().split('|');
            if (parts.length > 1) {
                name.value = parts[0];
                signature.value = parts[1];
                signaturePad.value!.fromDataURL(signature.value);
            }
        }
        int = window.setInterval(() => {
            saveSignature();
        }, 1000);
    }
    const validate = () :  'under' | 'over' | 'invalid' | 'ok' | 'ignore' | 'error' => {
        if (signaturePad.value!.isEmpty()) {
            error.value = true;
            return "error";
        }
        if (isBlankOrEmpty(name.value)) {
            error.value = true;
            return "error";
        }
        const img = signaturePad.value!.save();
        const val = name.value + "|" + (!signaturePad.value!.isEmpty() ? img : '')
        return  /([^\|]+)\|([^\|\s]+)/.test(val as string) ? "ok" : "error";
    }
    const value = () => {
        const img = signaturePad.value!.save();
        const val = name.value + "|" + (!signaturePad.value!.isEmpty() ? img : '')

        return name.value + "|" + (!signaturePad.value!.isEmpty() ? img : '');
    }
    const updateName = (e:any) => {
        name.value = e.target.value;
        emit("update")
    }
    const setName = (nme: string) => {
        name.value = nme;
        emit("update")
    }
    defineExpose({ validate, load, value, setName });
</script>

<template>
    <div>
        <div style="position:relative; width: 550px; max-width:100%; margin: 0 auto;">
            <div class="signature-pad-container">
                <Vue3Signature
                    ref="signaturePad"
                    :disabled="signaturePadState.disabled"
                    :sigOption="signaturePadState.option"
                ></Vue3Signature>
            </div>
            <div class="eraser">
                <i @click="clearSignature" class="fas fa-eraser"></i>
            </div>
        </div>

        <div class="name-container" style="margin-top: 30px;">
            <label>Your Name:</label>
            <el-input @keyup="saveSignature" autocomplete="off" v-model="name" placeholder="Enter your name" @blur="updateName"></el-input>
            <div v-if="error" style="color: red">Please sign and enter your name</div>
        </div>
    </div>
</template>

<style scoped>
.signature-pad-container {
  border: #7d7d7d 2px solid;
  width: 550px;
  height: 200px;
  margin: 0 auto;
  padding: 1px;
  /*position:relative;*/
  max-width:80%;
}
.name-container {
    height:100%;
    width: 550px;
    max-width:80%;
    margin: 0 auto;
}
.eraser{
  font-size: 2em;
  position: absolute;
  bottom: -50px;
  right: 30px;
}
</style>